import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

import Swiper from 'swiper/bundle';

const context = '.page-template-template-territorio section:not(.hero)';

if (document.querySelector(context)) {

    let mm = gsap.matchMedia();

    let textTerritorioArray = gsap.utils.toArray([`${context} h2`, `${context} h3`, `${context} h4`, `${context} h5`, `${context} h6`, `${context} p`, `${context} button`, `${context}#territorio2 .box`]);
    let imgArray = gsap.utils.toArray([`${context} .width-animation`, `${context} .width-animation-reverse`, `${context} .height-animation`, `${context} .height-animation-reverse`]);


    let swiperMetodo = new Swiper('.slider-metodo', {
        slidesPerView: 1,
        freeMode: true,
        centeredSlides: true,
        mousewheel: false,
        allowTouchMove: false,
        allowSlideNext: false,
        allowSlidePrev: false,
        breakpoints: {
            768: {
                slidesPerView: 1,
                slidesOffsetBefore: 50,
                slidesOffsetAfter: 50,
            },
            1440: {
                slidesPerView: 2,
            },
        },
    });

    const nSlides = swiperMetodo.slides.length

    mm.add({
        isMobile: "(max-width: 767px)",
        isDesktop: "(min-width: 768px)"
    }, (animContext) => {
        let { isMobile, isDesktop } = animContext.conditions;
        let offset = isMobile ? 100 : 200;
        let sliderVelocity = isMobile ? 500 : 1000;

        textTerritorioArray.forEach(text => {
            let textTerritorioTl = gsap.timeline({
                scrollTrigger: {
                    trigger: text,
                    start: `top bottom-=${offset}`,
                    end: 'bottom top',
                    once: true,
                }
            });
            textTerritorioTl.from(text, {opacity: 0, duration: 1, y: 20});
        });

        if (isMobile) {
            swiperMetodo.setProgress(0);
            swiperMetodo.disable();
        }

        if (!isMobile) {
            swiperMetodo.enable();
            let sliderPin = gsap.timeline({
                scrollTrigger: {
                    trigger: '#territorio5',
                    start: 'top top',
                    end: `+=${sliderVelocity*nSlides}`,
                    scrub: true,
                    pin: '#territorio5',
                    onUpdate: (self) => {
                        swiperMetodo.setProgress(self.progress * 1.05);
                    },
                }
            });

            swiperMetodo.on('resize', () => {
                sliderPin.refresh();
            });
        }

        let territorioPin = gsap.timeline({
            scrollTrigger: {
                trigger: '#territorio3 .full-container',
                start: `top-=${offset} top`,
                end: 'bottom bottom',
                scrub: true,
                pin: '#territorio3 .full-container .decorazione',
            }
        });

        imgArray.forEach(img => {
            gsap.timeline({
                scrollTrigger: {
                    trigger: img,
                    start: `top bottom-=${offset}`,
                    end: 'bottom top',
                    once: true,
                    onUpdate: self => {
                        self.trigger.style.setProperty('--animWidth', "100%");
                    },
                }
            });
        });

    });
}